<!-- 血圧のチャート -->

<template>
  <div class="small">
    <line-chart :chartdata="chartdata" :options="options" :width="1000"></line-chart>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import LineChart from "./LineChart.js";

export default {
  components: {
    LineChart
  },
  props: {
    label: VueTypes.arrayOf(VueTypes.string).isRequired,
    bloodHigh: VueTypes.arrayOf(VueTypes.number).def(0),
    bloodLow: VueTypes.arrayOf(VueTypes.number).def(0)
  },
  data() {
    return {
      options: {
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMax: 250,
                suggestedMin: 0,
                stepSize: 10
              }
            }
          ]
        }
      },
    };
  },
  computed: {
    chartdata () {
      return {
        labels: this.label,
        datasets: [
          {
            label: this.$t('notebook.sbp'),
            borderColor: "#95BE91",
            backgroundColor: "rgba(0, 0, 0, 0)",
            lineTension: 0,
            data: this.bloodHigh
          },
          {
            label: this.$t('notebook.dbp'),
            borderColor: "#44A0DA",
            backgroundColor: "rgba(0, 0, 0, 0)",
            lineTension: 0,
            data: this.bloodLow
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
.small {
  margin: auto;
}
</style>